import {EventBus} from "@/event-bus";
import Trimaster from "@/plugins/servers/trimaster";

import {
  loadBatchActions,
  doBatchCo2Calibration,
  doBatchIrrigation,
  doBatchBashCommand,
  doBatchIrrigationStop,
  doBatchSetIntensity,
  doBatchSetControlLoops,
  doBatchSetDebug,
  doRefreshSoilSensors,
  doBatchSetHeatStrip,
  onUpgradeClient,
  onUpgradeOS,
  forceSync,
  IRRIGATE_ACTION_ID,
  CALIBRATE_CO2_ACTION_ID,
  SET_INTENSITY_ACTION_ID,
  ASSIGN_CONTROL_LOOPS_ACTION_ID,
  UPDATE_HOST_NAME_ACTION_ID,
  UPGRADE_FIRMWARE_ACTION_ID,
  EXECUTE_BASH_COMMAND_ACTION_ID,
  MOVE_RACK_ACTION_ID,
  STOP_ALL_IRRIGATION_ACTION_ID,
  DEBUG_MODE_ON_ACTION_ID,
  DEBUG_MODE_OFF_ACTION_ID,
  UPGRADE_CLIENT_ACTION_ID,
  UPGRADE_OS_ACTION_ID,
  FORCE_SYNC_ACTION_ID,
  AUTOMATIC_MODE_ACTION_ID,
  MANUAL_MODE_ACTION_ID,
  IPM_APPLICATION_ACTION_ID,
  IPM_LOCK_ACTION_ID,
  MAINTENANCE_MODE_ACTION_ID,
  LIGHT_ACTION_ID,
  DARK_ACTION_ID,
  RELOAD_LIFECYCLES_ACTION_ID,
  RESTART_CONTROLLER_ACTION_ID,
  STANDBY_ACTION_ID,
  CURTAINS_UP_ACTION_ID,
  IMPAIRED_CHILLER_ACTION_ID,
  LOG_HARDWARE_STATES_ACTION_ID,
  REFRESH_SOIL_READINGS_ACTION_ID,
  STERILIZE_ACTION_ID,
  SERVICE_MODE_ACTION_ID,
  doBatchSetImpairedChiller,
  ASSIGN_PLATFORM_GROUP_COLLECTION_ACTION_ID,
  UNASSIGN_PLATFORM_GROUP_COLLECTION_ACTION_ID,
} from '@/services/batchActions';
import vuetifyToast from "@/vuetifyToast";
import store from "@/store";

const state = {
  batchActions: [],
  isBatchActionRunning: false,
}

const getters = {
  batchActions: (state) => state.batchActions,
  isBatchActionRunning: (state) => state.isBatchActionRunning,
}

const actions = {
  async loadBatchActions({state, commit}, forceLoadActionId = null) {
    if (!state.batchActions.length || forceLoadActionId) {
      const batchActions = await loadBatchActions(forceLoadActionId)
      commit('setBatchActions', batchActions)
      return batchActions;
    } else {
      return [ ...state.batchActions ]
    }
  },
  setBatchActionLabel({commit}, payload) {
    commit('setBatchActionLabel', payload)
  },
  setIsBatchActionRunning({commit}, isBatchActionRunning) {
    commit('setIsBatchActionRunning', isBatchActionRunning)
  },
  async changeBatchAction({commit, dispatch, state}, actionId) {

    await store.dispatch('universalDashboard/setSelectedBatchAction', actionId)
    let selectedBatchAction = state.batchActions.find(batchAction => batchAction.id === actionId);
    if (selectedBatchAction && selectedBatchAction.actionId) {
      actionId = selectedBatchAction.actionId
    }

    if (!actionId) {
      // reset prompts
      commit('setBatchActionLabel', {
        id: IRRIGATE_ACTION_ID,
        label: 'Irrigate'
      })
      commit('setBatchActionLabel', {
        id: EXECUTE_BASH_COMMAND_ACTION_ID,
        label: 'Execute Bash Command'
      })
      commit('setBatchActionLabel', {
        id: CALIBRATE_CO2_ACTION_ID,
        label: 'Calibrate CO2 Sensor'
      })
      commit('setBatchActionLabel', {
        id: SET_INTENSITY_ACTION_ID,
        label: 'Set Intensity to ' + Math.round(intensityValue * 100)
      })
      commit('setBatchActionLabel', {
        id: IMPAIRED_CHILLER_ACTION_ID,
        label: 'Set Impaired Chiller Intensity to ' + Math.round(intensityValue * 100)
      })
      await store.dispatch('universalDashboard/setIrrigationSettings', {
        designatorName: null,
        designator_id: null,
        durationSeconds: null,
        setAutoWhenComplete: false
      })
      await store.dispatch('universalDashboard/setBashSettings', null)
    } else if (actionId === IRRIGATE_ACTION_ID) {
      // configure irrigation options
      await store.dispatch('universalDashboard/setShowBatchIrrigationOptions', true)
    } else if (actionId === CALIBRATE_CO2_ACTION_ID) {
      // configure co2 manual calibration setting
      await store.dispatch('universalDashboard/setShowBatchCo2CalibrationOptions', true)
    } else if (actionId === SET_INTENSITY_ACTION_ID) {
      await store.dispatch('universalDashboard/setShowBatchIntensityOptions', true)
    } else if (actionId === IMPAIRED_CHILLER_ACTION_ID) {
      await store.dispatch('universalDashboard/setShowBatchImpairedChillerOptions', true)
    } else if (actionId === ASSIGN_CONTROL_LOOPS_ACTION_ID) {
      await store.dispatch('universalDashboard/setShowBatchControlLoopOptions', true)
    } else if (actionId === UPDATE_HOST_NAME_ACTION_ID) {
      await store.dispatch('universalDashboard/setIsUpdatingHostname', true)
    } else if (actionId === UPGRADE_FIRMWARE_ACTION_ID) {
      await store.dispatch('universalDashboard/setIsUpgradingFirmware', true)
    } else if (actionId === EXECUTE_BASH_COMMAND_ACTION_ID) {
      await store.dispatch('universalDashboard/setShowBashCommands', true)
    } else if (actionId === MOVE_RACK_ACTION_ID) {
      await store.dispatch('universalDashboard/setIsMovingPlatformGroup', true)
    } else if (actionId === ASSIGN_PLATFORM_GROUP_COLLECTION_ACTION_ID) {
      await store.dispatch('universalDashboard/setIsAssigningPlatformGroupCollection', true)
    } else if (actionId === UNASSIGN_PLATFORM_GROUP_COLLECTION_ACTION_ID) {
      await store.dispatch('universalDashboard/setIsUnassigningPlatformGroupCollection', true)
    } else if (actionId === STERILIZE_ACTION_ID) {
      await store.dispatch('universalDashboard/setShowSterilizeOptions', true)
    }  else if (store.getters['universalDashboard/isPerformingContextMenuAction']) {
      dispatch('runBatchAction')
    }
  },
  async runBatchAction({state, commit}) {
    if (state.isBatchActionRunning) {
      vuetifyToast.error("Please wait for the current request to complete.");
      return;
    }
    let selected = [];
    commit('setIsBatchActionRunning', true)
    if (store.getters['universalDashboard/isPerformingContextMenuAction']) {
      selected = [store.getters['universalDashboard/selectedContextMenuItem']];
    } else {
      selected = store.getters['universalDashboard/selectedUnits'];
    }
    let ids = selected.map((el) => el.controller_id);

    let selectedBatchAction = state.batchActions.filter(
      (batchAction) => batchAction.id === store.getters['universalDashboard/selectedBatchAction']
    )[0];
    selectedBatchAction = {...selectedBatchAction}
    if (selectedBatchAction.actionId) {
      selectedBatchAction.id = selectedBatchAction.actionId
    }

    if (selectedBatchAction.id === CALIBRATE_CO2_ACTION_ID) {
      doBatchCo2Calibration(selected);
    } else if (selectedBatchAction.id === IRRIGATE_ACTION_ID) {
      doBatchIrrigation(selected);
    } else if (selectedBatchAction.id === EXECUTE_BASH_COMMAND_ACTION_ID) {
      doBatchBashCommand(selected);
    } else if (selectedBatchAction.id === STOP_ALL_IRRIGATION_ACTION_ID) {
      doBatchIrrigationStop(selected);
    } else if (selectedBatchAction.id === SET_INTENSITY_ACTION_ID) {
      doBatchSetIntensity(selected);
    } else if (selectedBatchAction.id === IMPAIRED_CHILLER_ACTION_ID) {
      doBatchSetImpairedChiller(selected);
    } else if (selectedBatchAction.id === ASSIGN_CONTROL_LOOPS_ACTION_ID) {
      doBatchSetControlLoops(selected);
    } else if (
      selectedBatchAction.id === DEBUG_MODE_ON_ACTION_ID ||
      selectedBatchAction.id === DEBUG_MODE_OFF_ACTION_ID
    ) {
      doBatchSetDebug(selected, selectedBatchAction.value);
    } else if (selectedBatchAction.id === REFRESH_SOIL_READINGS_ACTION_ID) {
      doRefreshSoilSensors(selected, selectedBatchAction.value);
    } else if (
      selectedBatchAction.id === 100 ||
      selectedBatchAction.id === 101
    ) {
      doBatchSetHeatStrip(selected, selectedBatchAction.id);
    } else if (selectedBatchAction.id === UPGRADE_CLIENT_ACTION_ID) {
      onUpgradeClient();
    } else if (selectedBatchAction.id === UPGRADE_OS_ACTION_ID) {
      onUpgradeOS();
    } else if (selectedBatchAction.id === FORCE_SYNC_ACTION_ID) {
      forceSync();
    } else {
      let specialIds = [
        AUTOMATIC_MODE_ACTION_ID,
        MANUAL_MODE_ACTION_ID,
        SERVICE_MODE_ACTION_ID,
        IPM_APPLICATION_ACTION_ID,
        IPM_LOCK_ACTION_ID,
        MAINTENANCE_MODE_ACTION_ID,
        LIGHT_ACTION_ID,
        DARK_ACTION_ID,
        RELOAD_LIFECYCLES_ACTION_ID,
        RESTART_CONTROLLER_ACTION_ID,
        STANDBY_ACTION_ID,
        CURTAINS_UP_ACTION_ID,
        IMPAIRED_CHILLER_ACTION_ID,
        LOG_HARDWARE_STATES_ACTION_ID,
        STERILIZE_ACTION_ID,
      ];

      if (!specialIds.includes(selectedBatchAction.id)) {
        let promises = [];

        if (selectedBatchAction.deviceTypeId === 18) {
          // co2

          let bardControllerIds = selected
            .filter((a) => a.BardState != "")
            .map((a) => a.controller_id);
          let ecuControllerIds = selected
            .filter((a) => a.ECUState != "")
            .map((a) => a.controller_id);

          if (bardControllerIds.length > 0) {
            promises.push(
              Trimaster.post(
                "controllerCommands/executeComplexBatchCommand",
                store.getters['getUser'].apitoken,
                {
                  controller_ids: bardControllerIds,
                  command: selectedBatchAction.value,
                  virtualDeviceType_id: 39,
                }
              )
            );
          }

          if (ecuControllerIds.length > 0) {
            promises.push(
              Trimaster.post(
                "controllerCommands/executeComplexBatchCommand",
                store.getters['getUser'].apitoken,
                {
                  controller_ids: ecuControllerIds,
                  command: selectedBatchAction.value,
                  virtualDeviceType_id: 18,
                }
              )
            );
          }
        } else {
          promises.push(
            Trimaster.post(
              "controllerCommands/executeComplexBatchCommand",
              store.getters['getUser'].apitoken,
              {
                controller_ids: ids,
                command: selectedBatchAction.value,
                virtualDeviceType_id: selectedBatchAction.deviceTypeId,
              }
            )
          );
        }

        let [res, err] = await Promise.all(promises)
        if (err) {
          vuetifyToast.error("Request Failed. Please try again later.");
        } else {
          vuetifyToast.success("Batch process completed!");
          await store.dispatch('universalDashboard/setSelectedBatchAction', 0);
        }
        commit('setIsBatchActionRunning', false)
      } else {
        // SPECIAL CONTROLLER/DEVICE ACTIONS

        let commands = [];

        for (let i = 0; i < selected.length; i++) {
          commands.push({
            controller_id: selected[i].controller_id,
            virtualDevice_id: selected[i].id,
            action_id: selectedBatchAction.id,
            user_id: store.getters['getUser'].id,
            platformGroup_id: selected[i].platformGroup_id,
          });

          if ([AUTOMATIC_MODE_ACTION_ID, MANUAL_MODE_ACTION_ID].includes(selectedBatchAction.id)) {
            EventBus.$emit('mode-of-operation-loading', {
              platformGroupId: selected[i].platformGroup_id,
              isLoading: true
            })
            EventBus.$emit('current-state-loading', {
              platformGroupId: selected[i].platformGroup_id,
              isLoading: true
            })
          }
        }

        // handle automatic vs manual
        let [res, err] = await Trimaster.post(
          "controllerCommands",
          store.getters['getUser'].apitoken,
          commands
        )
        if (err) {
          vuetifyToast.error("An error occurred. Please try again later.");
        } else {
          vuetifyToast.success(
            "Commands were successfully added to the queue"
          );
          await store.dispatch('universalDashboard/setSelectedBatchAction', 0);
        }
        commit('setIsBatchActionRunning', false)
      }
    }
    await store.dispatch('universalDashboard/setIsPerformingContextMenuAction', false)
  }
}

const mutations = {
  setBatchActions(state, batchActions) {
    state.batchActions = batchActions
  },
  setBatchActionLabel(state, payload) {
    if (payload.id && payload.label) {
      let batchAction = state.batchActions.find(
        (action) => action.id === payload.id
      )
      if (batchAction) {
        batchAction.label = payload.label
      }
    }
  },
  setIsBatchActionRunning(state, isBatchActionRunning) {
    state.isBatchActionRunning = isBatchActionRunning
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
